import { SUCCESSION_USER_INDICATOR_KEYS } from 'constants/succession';
import { formatDate } from 'utility/dateUtils';
import {
  prepareChangeLogEntryAction,
  prepareChangeLogEntryCreator,
} from 'utility/succession';

const textColumn = (id, title, rowKey, minWidth, maxWidth = '1fr') => ({
  id,
  title,
  rowKey,
  isSortingDisabled: true,
  minWidth,
  maxWidth,
});

export const prepareHolderHeaders = labels => [
  textColumn('employee', labels.employee, 'employee', 220),
  textColumn('level', labels.level, 'level', 120),
  textColumn('manager', labels.manager, 'manager', 220),
  textColumn('tenure', labels.tenure, 'tenure', 120, 180),
];

export const prepareSuccessorHeaders = labels => [
  textColumn('employee', labels.employee, 'employee', 220),
  textColumn('readiness', labels.readiness, 'readiness', 140),
  textColumn('rank', labels.rank, 'rank', 80),
  textColumn('note', labels.note, 'note', 180),
  textColumn('status', labels.status, 'statusComponent', 110, 140),
];

export const prepareChangelogHeaders = labels => [
  textColumn('when', labels.when, 'when', 140),
  textColumn('who', labels.who, 'who', 220),
  textColumn('action', labels.action, 'action', 240),
];

export const prepareHolderRows = (holders, labels, renderEmployee) =>
  (holders || []).map(holder => ({
    id: holder.id,
    employee: renderEmployee(holder),
    level: '-',
    manager: '-',
    tenure: '-',
  }));

export const prepareSuccessorRows = (
  labels,
  successors,
  renderPerson,
  renderActions,
  renderStatus
) =>
  (successors || []).map(successor => ({
    id: successor.employee.id,
    employee: renderPerson(successor.employee),
    readiness: successor?.readiness?.label || '-',
    rank: successor.rank,
    note: successor.note || '-',
    actions: renderActions(successor),
    status: successor?.status,
    statusComponent: successor?.status
      ? renderStatus({
          key: SUCCESSION_USER_INDICATOR_KEYS[successor.status],
          name: labels?.statuses?.[successor.status] || '-',
          value: successor.status,
        })
      : '-',
    successor,
  }));

export const prepareChangelogRows = (
  entries,
  labels,
  renderUser,
  renderChangeLogEntryAction
) =>
  (entries || []).map(entry => {
    return {
      id: entry.id,
      when: formatDate(entry?.created_at),
      who: prepareChangeLogEntryCreator(labels, entry, renderUser),
      action: prepareChangeLogEntryAction(
        labels,
        entry,
        renderChangeLogEntryAction
      ),
    };
  });
